module.exports = __webpack_public_path__ + "static/media/doacao.c842f071.svg";